module.exports = __webpack_public_path__ + "img/9788957985823.43a62d15.jpg";